/**
 * 認証エラーを表すカスタムエラークラスです。
 * サーバから返却されるエラーコード（例: "NotAuthorized", "RefreshTokenExpired"）を保持します。
 */
export class AuthError extends Error {
  /**
   * @param {string} code サーバから返却されるエラーコード
   * @param {string} [message] エラーメッセージ（省略時は code をメッセージとして使用）
   */
  constructor(code, message) {
    super(message ?? code);
    this.name = "AuthError";
    this.code = code;
  }
}
